<template>
  <div class="p-3 bg-gray-100 rounded-lg box-border shadow-xs">
    <slot />
  </div>
</template>
